import Image from 'next/image'
import { useGetBlackFriday } from '../../../hooks/marketing/useGetBlackFriday'
import { getBannerConfig } from '../../../common/utils/banner.holiday'

const { bottomBanner } = getBannerConfig()

type Props = {
  showDecoration?: boolean
  darkTheme?: boolean
}
export default function BlackFridayCardV2({ showDecoration = true, darkTheme = false }: Props) {
  const { data } = useGetBlackFriday()

  if (data?.countDown.values.seconds && data?.countDown.values.seconds <= 0) {
    return null
  }

  return (
    <div className={'relative'}>
      <div
        className={
          'relative w-full h-full rounded-[6px] border border-[#2C1149] overflow-hidden '
        }
      >
        {bottomBanner.bottomBannerRight && (
          <Image
            src={bottomBanner.bottomBannerRight}
            alt='Background'
            className='object-cover'
            fill={true}
          />
        )}

        <div
          className={
            'flex flex-row gap-1 items-center h-28 w-full text-body-medium text-white rounded-md pr-0 sm:pr-5 pointer-events-none'
          }
          style={{
            backgroundColor: bottomBanner.bgColor,
          }}
        >
          {/* <div className={'top-0 bottom-0 right-0 w-[78%] absolute z-20'}>
           <Image
              src={Background}
              alt={'Background'}
              className={'rounded-md '}
              fill={true}
              priority={true}
            />
          </div> */}

          <div
            className={
              'relative z-10 h-28 w-[58%] lg:w-[45%] xl:w-[35%] shrink-0'
            }
          >
            <Image
              src={bottomBanner.img}
              className={'object-cover'}
              alt={'New season'}
              fill={true}
            />
          </div>

          <div className={'flex flex-col gap-0'}>
            <p className={'text-2xs-medium z-20 font-bold '} style={{
              color: bottomBanner.titleColor,
            }}>
              {bottomBanner.title}
            </p>

            <div className={'flex flex-row gap-2 items-start z-20'}>
              <div className={'relative h-10 w-4 shrink-0 lg:flex hidden mt-1'}>
                <Image
                  src={bottomBanner.iconChecked}
                  alt={'checked icon'}
                  fill={true}
                />
              </div>

              <div
                className={
                  `max-w-full text-secondary-medium text-xs md:text-base lg:text-body-medium ${darkTheme ? 'text-white' : 'text-[#050608]'}`
                }
              >
                <span style={{
                  color: bottomBanner.textColor,
                }}>15% OFF </span><span>next 3 orders 🎆</span> <br />
                <span style={{
                  color: bottomBanner.textColor,
                }}>Code: </span> <span>JULY2025</span>
              </div>
            </div>

            {/*<div*/}
            {/*  className={'flex flex-row gap-2 items-start z-20 lg:ml-5 ml-2'}*/}
            {/*>*/}
            {/*  <div className={'relative h-4 w-4 shrink-0 lg:flex hidden mt-1'}>*/}
            {/*    <Image src={IconChecked} alt={'checked icon'} fill={true} />*/}
            {/*  </div>*/}

            {/*  <div*/}
            {/*    className={*/}
            {/*      'max-w-full text-secondary-medium md:text-body-medium'*/}
            {/*    }*/}
            {/*  >*/}
            {/*    Enjoy <span className={'text-[#6BEDFF]'}>5% off </span>*/}
            {/*    all packages!*/}
            {/*  </div>*/}
            {/*</div>*/}
          </div>

          {/* <button
            className={
              'btn border-none bg-[#8F15CD] pointer-events-auto hover:bg-[#8F15CD]  text-white rounded-lg z-20 font-oswald font-semibold  px-5 py-3 mx-3 hidden xl:flex transition-opacity duration-300 hover:opacity-80'
            }
          >
            BUY NOW!
          </button> */}
        </div>
      </div>
      {showDecoration && (
        <div
          className={'lg:flex hidden z-30'}
          style={{
            position: 'absolute',
            right: '-24px',
            top: '-24px',
            width: '50px',
            height: '50px',
          }}
        >
          <Image src={bottomBanner.decoration} alt={'Badge Icon'} fill={true} />
        </div>
      )}
    </div>
  )
}
